import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useNavigate } from 'react-router-dom';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { Link } from '@backstage/core-components';
import { coreComponentsTranslationRef } from '@backstage/core-components/alpha';
import { MicDrop } from './MicDrop';

interface IErrorPageProps {
  status?: string;
  statusMessage: string;
}

const useStyles = makeStyles(
  theme => ({
    container: {
      padding: theme.spacing(8),
      display: 'flex',
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2),
      },
    },
    content: {
      flexBasis: '40%',
      [theme.breakpoints.down('md')]: {
        flexBasis: '100%',
      },
    },
    title: {
      paddingBottom: theme.spacing(5),
      [theme.breakpoints.down('xs')]: {
        paddingBottom: theme.spacing(4),
        fontSize: theme.typography.h3.fontSize,
      },
    },
    subtitle: {
      color: theme.palette.textSubtle,
    },
  }),
  { name: 'BackstageErrorPage' },
);

export default function CustomErrorPage(props: IErrorPageProps) {
  const { status = '', statusMessage } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslationRef(coreComponentsTranslationRef);

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Typography
          data-testid="error"
          variant="body1"
          className={classes.subtitle}
        >
          {t('errorPage.subtitle', { status, statusMessage })}
        </Typography>
        <Typography variant="h2" className={classes.title}>
          {t('errorPage.title')}
        </Typography>
        <Typography variant="h6" className={classes.title}>
          <Link to="#" data-testid="go-back-link" onClick={() => navigate(-1)}>
            {t('errorPage.goBack')}
          </Link>
          ... or please{' '}
          <Link
            to="/contact-us"
            color="primary"
          >
            contact support
          </Link>{' '}
          if you think this is a bug.
        </Typography>
      </Box>
      <MicDrop />
    </Box>
  );
}
